import Behavior from './behavior';
import StrategyFactory from './factory';
import {
  ADBLOCK_READY_NS,
  EMBED_CONTAINER_SELECTOR
} from './constants';

const {RSVP} = window;

class Detector {
  constructor({disabledUserTypes, disabledCountries, disabledDevices, strategies, behavior, userType, device, countryCode}) {
    this.options = {disabledUserTypes, disabledCountries, disabledDevices, strategies, behavior, userType, device, countryCode};
    this.behavior   = new Behavior(this.options.behavior);
    this.strategies = [];

    _init.call(this);
  }
}

export default Detector;

/* Private */

function _init() {
  this.options.strategies.forEach(strategy => {
    this.strategies.push(StrategyFactory.create(strategy.type, strategy.config));
  });

  _findAdblocker.call(this);
}

function _hasNoStrategies() {
  return this.strategies.length === 0;
}

function _isDisabledUserType() {
  return this.options.userType !== '' && this.options.disabledUserTypes.find(type => type === this.options.userType);
}

function _isDisabledCountry() {
  return this.options.countryCode !== '' &&
    (this.options.disabledCountries.find(type => type === this.options.countryCode) ||
    (this.options.disabledCountries.find(type => type === 'ALL') &&
     !this.options.disabledCountries.find(type => type === `!${this.options.countryCode}`)));
}

function _isDisabledDevice() {
  return this.options.device !== '' && this.options.disabledDevices.find(type => type === this.options.device);
}

function _findAdblocker() {
  this.strategies.forEach(strategy => {
    RSVP.all(strategy.promises)
      .then(() => window.__VOONTO__.promised(ADBLOCK_READY_NS, false))
      .catch(() => {
        if (_hasNoStrategies.call(this) ||
            _isDisabledUserType.call(this) ||
            _isDisabledCountry.call(this) ||
            _isDisabledDevice.call(this)) {
          window.__VOONTO__.promised(ADBLOCK_READY_NS, true);
          return;
        }

        // NOTE: adblocker detected
        window.__VOONTO__.when('voonto:ready').then(() => {
          /* FUTURE: This condition avoids the REDIRECT behavior, due to this,
           * in pages that the adbd should not be executed, the adbd.js should
           * not be loaded.
           */
          if (window.Voonto.$(EMBED_CONTAINER_SELECTOR).length) {
            this.behavior.init();
          }
        });
        window.__VOONTO__.promised(ADBLOCK_READY_NS, true);
      })
    ;
  });
}



// WEBPACK FOOTER //
// ./src/detector.js